import { useReconciliationMerchants } from 'pages/Finance/Reconciliation/hooks/useReconciliationMerchants';
import { useReconciliationProviders } from 'pages/Finance/Reconciliation/hooks/useReconciliationProviders';
import { ReconciliationFormValues } from 'pages/Finance/Reconciliation/utils/mapReconciliationFormToFormData';
import { useWatch } from 'react-hook-form';
import { SelectInput } from 'shared/react-admin/Inputs';

type Props = {
  readOnly?: boolean;
};

export const ReconciliationProviderInput: React.FC<Props> = ({ readOnly }) => {
  const merchant = useWatch<ReconciliationFormValues>({ name: 'merchant' });
  const { data: merchants } = useReconciliationMerchants();
  const merchantAlias = merchants?.find(({ id }) => id === merchant)?.alias;

  const { data: providers, isLoading } = useReconciliationProviders(merchantAlias);

  return (
    <SelectInput
      choices={providers ?? []}
      disabled={!merchantAlias}
      fullWidth
      isPending={isLoading}
      isRequired
      label="Провайдер"
      readOnly={readOnly}
      source="provider"
      variant="outlined"
    />
  );
};
